import './menuMain.scss';
import $ from 'jquery';

$(function() {

    // ARIA + active class
    $('.mainframe-menu .menu li .sub-menu').attr('aria-label','Sous-menu');
    $('.mainframe-menu .menu li.current-menu-ancestor').removeClass('active');
    $('.mainframe-menu .menu .menu-item-has-children>a').attr('aria-haspopup','true');
    $('.mainframe-menu .menu li.menu-item-has-children').hover(function(e){
        e.preventDefault();
        $(this).children('ul').stop().slideDown();
        $(this).addClass('active');
        $(this).parent().addClass('active');
        return;
    }, function(e){
        e.preventDefault();
        $(this).children('ul').stop().slideUp();
        $(this).removeClass('active');
        $(this).parent().removeClass('active');
        return;
    });

});